"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _lodash = require('lodash');
var _helpers = require('./helpers');
var _redux = require('redux');
var _store = require('shared/store');
var _utils = require('shared/store/utils');



















var _uuid = require('shared/services/uuid');
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _log = require('shared/log');





var _uploadFailure = require('shared/services/uploadFailure');
var _appState = require('shared/services/appState');





var _uploadDirect = require('shared/services/directUpload/uploadDirect');

var _uploadFileWithFallback = require('shared/services/directUpload/uploadFileWithFallback');
var _fetch = require('shared/services/client/BloomClient/fetch/fetch');






var _uploadProgress = require('shared/services/uploadProgress');
var _mentions = require('shared/services/mentions');
var _contactCap = require('shared/services/contactCap');
var _pendingSends = require('shared/services/pendingSends');
var _attachments = require('shared/constants/attachments');



















 const PENDING_REACTION_TIMEOUT_MS = 10000; exports.PENDING_REACTION_TIMEOUT_MS = PENDING_REACTION_TIMEOUT_MS

const hasPendingReaction = (
  ConversationKey,
  MessageKey,
  Emoji,
  opId,
) => _optionalChain([_store.getState.call(void 0, ), 'optionalAccess', _ => _.dataV2, 'access', _2 => _2.pendingReactions, 'optionalAccess', _3 => _3[ConversationKey], 'optionalAccess', _4 => _4[MessageKey], 'optionalAccess', _5 => _5[Emoji], 'optionalAccess', _6 => _6.opId]) === opId

const saveConversationDraftAction = _utils.createAction('Save conversation draft')
const pruneLocalMessageAction = _utils.createAction('Prune local message')
const expirePendingReactionAction =
  _utils.createAction('Expire pending reaction')

const startVideoChatActions = _utils.createAsyncActions('StartVideoChat')
const inviteVideoChatSmsActions = _utils.createAsyncActions('InviteVideoChatSms')
const inviteVideoChatEmailActions = _utils.createAsyncActions('InviteVideoChatEmail')
const loadConversationActions = _utils.createAsyncActions('LoadConversation')
const loadConversationAroundTimeActions =
  _utils.createAsyncActions('LoadConversationAroundTime')
const loadConversationAroundMessageActions =
  _utils.createAsyncActions('LoadConversationAroundMessage')
const sendMessageToConversationActions =
  _utils.createAsyncActions('SendMessageToConversation')
const sendFileToConversationActions =
  _utils.createAsyncActions('SendMessageToConversation (File)')
const deleteMessageFromConversationActions =
  _utils.createAsyncActions('DeleteMessageFromConversation')
const addMessageReactionActions =
  _utils.createAsyncActions('AddMessageReaction')
const removeMessageReactionActions =
  _utils.createAsyncActions('RemoveMessageReaction')
const addUserToConversationActions =
  _utils.createAsyncActions('AddUserToConversation')
const addTeamToConversationActions =
  _utils.createAsyncActions('AddTeamToConversation')
const uploadFileActions = _utils.createAsyncActions('HTTP file upload')

 const actionCreators = {
  saveConversationDraftAction,
  pruneLocalMessageAction,
  expirePendingReactionAction,
  startVideoChatActions,
  inviteVideoChatSmsActions,
  inviteVideoChatEmailActions,
  loadConversationActions,
  loadConversationAroundTimeActions,
  loadConversationAroundMessageActions,
  sendMessageToConversationActions,
  sendFileToConversationActions,
  deleteMessageFromConversationActions,
  addMessageReactionActions,
  removeMessageReactionActions,
  addUserToConversationActions,
  addTeamToConversationActions,
  uploadFileActions,
}; exports.actionCreators = actionCreators

const startVideoChat = () =>
  _helpers.wsCommand('StartVideoChat', startVideoChatActions, {}, null)

const inviteVideoChatSms = (req) =>
  _helpers.wsCommand('InviteVideoChatSms', inviteVideoChatSmsActions, req, null)

const inviteVideoChatEmail = (req) =>
  _helpers.wsCommand('InviteVideoChatEmail', inviteVideoChatEmailActions, req, null)

const loadConversation = (req) =>
  _helpers.wsCommand('LoadConversation', loadConversationActions, req, null)

const loadConversationAroundTime = (req) =>
  _helpers.wsCommand(
    'LoadConversationAroundTime',
    loadConversationAroundTimeActions,
    req,
    null,
  )

const loadConversationAroundMessage = (req) =>
  _helpers.wsCommand(
    'LoadConversationAroundMessage',
    loadConversationAroundMessageActions,
    req,
    null,
  )

/* A failed part of a send (rows sharing a sender and SentAt) keeps the send's
 * SentAt when retried, so it lands back in its group; the server honours a
 * recent one. A message sent on its own gets the server's time, as before. */
const sendSentAtOf = (ConversationKey, MessageKey) => {
  const rows = _optionalChain([_store.getState.call(void 0, ), 'optionalAccess', _7 => _7.dataV2, 'access', _8 => _8.messages, 'access', _9 => _9[ConversationKey]]) || []
  const row = rows.find(m => m.MessageKey === MessageKey)
  if (!row) return undefined
  const send = { SentAt: row.SentAt, UserKey: row.UserKey }
  const partOfSend = rows.some(m => m.MessageKey !== MessageKey && _lodash.isMatch.call(void 0, m, send))
  return partOfSend ? row.SentAt : undefined
}

const sendConversationMessage = (
  ConversationKey,
  TextContent,
  FileKey,
  messageKey,
  replyToMessageKey,
  replyPreview,
  mentions,
) => {
  const hasProvidedMentions = mentions !== undefined
  if (hasProvidedMentions) {
    const normalized = _mentions.normalizeMessageWithMentions.call(void 0, TextContent, mentions || [])
    TextContent = normalized.text
    mentions = normalized.mentions
  }
  const isRetrying = !!messageKey
  const MessageKey = (messageKey || _uuid.uuidv4.call(void 0, )) 
  const existingMessage = isRetrying
    ? _optionalChain([_store.getState.call(void 0, ), 'optionalAccess', _10 => _10.dataV2, 'access', _11 => _11.messages, 'access', _12 => _12[ConversationKey], 'optionalAccess', _13 => _13.find, 'call', _14 => _14(m => m.MessageKey === MessageKey)])
    : undefined
  const ReplyToMessageKey = replyToMessageKey || _optionalChain([existingMessage, 'optionalAccess', _15 => _15.ReplyToMessageKey])
  const resolvedReplyPreview = replyPreview || _optionalChain([existingMessage, 'optionalAccess', _16 => _16.ReplyPreview])
  const resolvedMentions = hasProvidedMentions ? mentions : _optionalChain([existingMessage, 'optionalAccess', _17 => _17.Mentions])
  const SentAt = isRetrying ? sendSentAtOf(ConversationKey, MessageKey) : undefined

  _contactCap.contactCapBlockStore.set(MessageKey, null)
  return _helpers.wsCommand(
    'SendMessageToConversation',
    sendMessageToConversationActions,
    {
      ConversationKey,
      MessageKey,
      TextContent,
      FileKey,
      ...(ReplyToMessageKey ? { ReplyToMessageKey } : {}),
      ...(_optionalChain([resolvedMentions, 'optionalAccess', _18 => _18.length]) ? { Mentions: resolvedMentions } : {}),
      ...(SentAt ? { SentAt } : {}),
    },
    {
      ConversationKey,
      MessageKey,
      isRetrying,
      ...(SentAt ? { SentAt } : {}),
      ...(ReplyToMessageKey ? { ReplyToMessageKey } : {}),
      ...(resolvedReplyPreview ? { ReplyPreview: resolvedReplyPreview } : {}),
      ...(_optionalChain([resolvedMentions, 'optionalAccess', _19 => _19.length]) ? { Mentions: resolvedMentions } : {}),
    },
  ).catch((err) => {
    // The message stays failed; remember why so its row can say so.
    _contactCap.contactCapBlockStore.set(MessageKey, _contactCap.contactCapBlockFromError.call(void 0, err))
    throw err
  })
}

const deleteMessageFromConversation = (MessageKey, ConversationKey) =>
  _helpers.wsCommand(
    'DeleteMessageFromConversation',
    deleteMessageFromConversationActions,
    { MessageKey },
    { ConversationKey },
  )

const addMessageReaction = (
  MessageKey,
  Emoji,
  ConversationKey,
) => {
  const opId = _uuid.uuidv4.call(void 0, )
  return _helpers.wsCommand(
    'AddMessageReaction',
    addMessageReactionActions,
    { MessageKey, Emoji },
    { ConversationKey, opId },
  ).then(response => {
    setTimeout(() => {
      if (hasPendingReaction(ConversationKey, MessageKey, Emoji, opId)) {
        _store.dispatch.call(void 0, expirePendingReactionAction({ ConversationKey, MessageKey, Emoji, opId }))
      }
    }, exports.PENDING_REACTION_TIMEOUT_MS)
    return response
  })
}

const removeMessageReaction = (
  MessageKey,
  Emoji,
  ConversationKey,
) => {
  const opId = _uuid.uuidv4.call(void 0, )
  return _helpers.wsCommand(
    'RemoveMessageReaction',
    removeMessageReactionActions,
    { MessageKey, Emoji },
    { ConversationKey, opId },
  ).then(response => {
    setTimeout(() => {
      if (hasPendingReaction(ConversationKey, MessageKey, Emoji, opId)) {
        _store.dispatch.call(void 0, expirePendingReactionAction({ ConversationKey, MessageKey, Emoji, opId }))
      }
    }, exports.PENDING_REACTION_TIMEOUT_MS)
    return response
  })
}

const rejoinConversation = (
  req,
) => 'TeamKey' in req
  ? _helpers.wsCommand('AddTeamToConversation', addTeamToConversationActions, req, null)
  : _helpers.wsCommand('AddUserToConversation', addUserToConversationActions, req, null)

const boundActions = _redux.bindActionCreators.call(void 0, {
  saveConversationDraft: saveConversationDraftAction,
  pruneLocalMessage: pruneLocalMessageAction,
}, _store.dispatch)

const sentFiles = {}
const uploadTrackers = {}
// Each message's direct upload session, so a Retry can finish an upload
// whose bytes already landed instead of sending them again.
const directUploadKeys = {}
// Messages whose file is in GCS for the attempt in progress.
const landedUploads = new Set()
// Messages a direct completion already posted: the send that follows is a
// duplicate, so its failure doesn't make the message "Not sent".
const postedByCompletion = new Set()
// Messages that failed "Not sent": a Retry first just completes them by key.
const notSentUploads = new Set()
const uploadAbortControllers = {}
// Why an upload's signal fired: the user cancelled, or it ran out of time.
// RestFetch rewrites an AbortError into a generic RestError, so the error
// itself cannot tell us.
const userAbortedUploads = new Set()
const timedOutUploads = new Set()
// Which path carried (or was carrying) a send's bytes, for its failure report.

const uploadTransports = new Map()

// Checks (and may repair) a file right before each upload attempt, first send
// and retry alike. Mobile registers one that confirms the video and poster
// are still on disk: React Native on iOS never reports a multipart body it
// could not build, so a missing file would leave the send hanging until the
// upload timeout. Resolve the file to send, or reject to fail the attempt.

let uploadFileCheck = null
 const setUploadFileCheck = (check) => { uploadFileCheck = check }; exports.setUploadFileCheck = setUploadFileCheck

// Moves a message attachment straight to GCS (mobile: the background
// uploader; web: chunked XHR). The platform registers one; it resolves null
// for a file it can't take, which then goes through /upload_file.
// Completing the upload posts the message, under the same MessageKey the
// send below uses, so the send is a harmless duplicate. The native uploader
// completes it itself as soon as the bytes land, even with the app gone; the
// server never posts a message on its own.









let messageUploadTransport = null
// Told when a Retry settled an upload by key outside its transport
// (completed, or cancelled), so the platform can drop its record and any
// "wasn't sent" notice.

let directUploadSettled = null
 const setDirectUploadSettled = (handler) => { directUploadSettled = handler }; exports.setDirectUploadSettled = setDirectUploadSettled
// A by-key completion worth trying again later: no answer (timeout, socket)
// or the server still finishing. Any other refusal means sending again.
const COMPLETE_LATER_ERRORS = new Set(['upload is finishing', 'upload is not finished'])
const canCompleteLater = (err) => {
  const { Status, Error } = (_nullishCoalesce(err, () => ( {}))) 
  return Status !== 'client_error' || COMPLETE_LATER_ERRORS.has(_nullishCoalesce(Error, () => ( '')))
}
const isUploadNotFinished = (err) => _optionalChain([(err ), 'optionalAccess', _20 => _20.Error]) === 'upload is not finished'
 const setMessageUploadTransport = (factory) => { messageUploadTransport = factory }; exports.setMessageUploadTransport = setMessageUploadTransport




























// Rejects every part that uploaded when a sibling did not, so each shows as
// not sent. The sibling that failed reports the cause; this is not reported.
class AttachmentNotSentError extends Error {
  constructor () {
    super('An attachment could not be sent')
    this.name = 'AttachmentNotSentError'
  }
}

/* The server reads only about ten commands from a connection at a time and
 * drops the rest (ProcessMessageBuffer in apps/backend/client/client.go), so a
 * send's files upload a few at a time: 20 StartUploads at once lost 9. */
const MAX_PARALLEL_PART_UPLOADS = 4
// Resolves with a release once a slot is free; rejects if the part is
// cancelled while it waits.

const createUploadSlots = (size) => {
  let free = size
  const waiting = []
  const release = () => {
    const next = waiting.shift()
    if (next) next()
    else free += 1
  }
  return signal => new Promise((resolve, reject) => {
    let released = false
    const grant = () => {
      _optionalChain([signal, 'access', _21 => _21.removeEventListener, 'optionalCall', _22 => _22('abort', onAbort)])
      resolve(() => {
        if (released) return
        released = true
        release()
      })
    }
    const onAbort = () => {
      const i = waiting.indexOf(grant)
      if (i >= 0) waiting.splice(i, 1)
      const error = new Error('Upload aborted')
      error.name = 'AbortError'
      reject(error)
    }
    if (free > 0) {
      free -= 1
      grant()
      return
    }
    waiting.push(grant)
    _optionalChain([signal, 'access', _23 => _23.addEventListener, 'optionalCall', _24 => _24('abort', onAbort)])
  })
}

const uploadFile = async (
  givenFile,
  MessageKey,
  ConversationKey,
  isRetrying,
  part,
  // A retried part of a send: upload the file only, and post it with this
  // SentAt (see sendSentAtOf).
  retrySentAt,
) => {
  let file = givenFile
  let controller
  // Upload the file only; the caller posts it.
  const fileOnly = !!part || !!retrySentAt
  const meta = {
    MessageKey,
    isRetrying,
    ...(part
      ? { SentAt: part.SentAt, ReplyToMessageKey: part.ReplyToMessageKey, ReplyPreview: part.ReplyPreview }
      : retrySentAt ? { SentAt: retrySentAt } : {}),
  }

  _store.dispatch.call(void 0, uploadFileActions.REQUEST({ file, ConversationKey }, meta))

  try {
    controller = new AbortController()
  } catch (e) {
    // Failed to create AbortController, using fallback
    controller = { signal: {} , abort: () => null }
  }

  uploadAbortControllers[MessageKey] = controller
  uploadTransports.delete(MessageKey)

  let tracker = _uploadProgress.createUploadProgressTracker.call(void 0, MessageKey, file.size)
  uploadTrackers[MessageKey] = tracker
  landedUploads.delete(MessageKey)
  _fetch.onUploadProgress.call(void 0, controller.signal, (sent, total) => tracker.bytes(sent, total))

  // Neither platform's fetch times out on its own, so a stalled upload would
  // spin forever. Abort it and let it fail visibly, with a retry.
  // Settles the wait without aborting (see pauseDeadlineWhileTransferring).
  let stopWaiting = () => undefined
  const stoppedWaiting = new Promise((_resolve, reject) => { stopWaiting = reject })
  stoppedWaiting.catch(() => undefined)

  // Counts only foreground time (shared/services/appState).
  let stopDeadline = () => undefined
  const armDeadline = (ms, onExpiry = 'abort') => {
    stopDeadline()
    stopDeadline = _appState.foregroundTimeout.call(void 0, ms, () => {
      timedOutUploads.add(MessageKey)
      if (onExpiry === 'abort') controller.abort()
      else stopWaiting(new Error('Upload timed out'))
    })
  }
  const clearDeadline = () => stopDeadline()
  // A file still being made has no deadline until it is ready.
  if (!_optionalChain([part, 'optionalAccess', _25 => _25.ready])) armDeadline(_uploadFailure.getUploadTimeoutMs.call(void 0, file.size))

  // Settle on abort even if the upload is stuck before fetch sees the signal
  // (e.g. React Native never reports a multipart body it could not build).
  const aborted = new Promise((_resolve, reject) => {
    const onAbort = () => {
      const error = new Error('Upload aborted')
      error.name = 'AbortError'
      reject(error)
    }
    if (controller.signal.aborted) onAbort()
    else _optionalChain([controller, 'access', _26 => _26.signal, 'access', _27 => _27.addEventListener, 'optionalCall', _28 => _28('abort', onAbort)])
  })
  // An abort after the upload settled has no one left to observe it.
  aborted.catch(() => undefined)

  if (_optionalChain([part, 'optionalAccess', _29 => _29.ready])) {
    try {
      file = await Promise.race([part.ready, aborted])
    } catch (err) {
      if (controller.signal.aborted) _optionalChain([part, 'access', _30 => _30.cancel, 'optionalCall', _31 => _31()])
      // Retry has nothing to send: the file was never made.
      sentFiles[MessageKey] = null
      throw err
    }
    // Retry resends the file that was made, and the row shows it.
    sentFiles[MessageKey] = file
    tracker = _uploadProgress.createUploadProgressTracker.call(void 0, MessageKey, file.size)
    uploadTrackers[MessageKey] = tracker
    _store.dispatch.call(void 0, uploadFileActions.REQUEST({ file, ConversationKey }, { ...meta, isRetrying: true }))
    armDeadline(_uploadFailure.getUploadTimeoutMs.call(void 0, file.size))
  }

  postedByCompletion.delete(MessageKey)
  let releaseSlot
  try {
    // A part waits for a free upload slot; its deadline starts once it has one.
    if (_optionalChain([part, 'optionalAccess', _32 => _32.uploadSlot])) {
      clearDeadline()
      const slot = part.uploadSlot(controller.signal)
      slot.catch(() => undefined)
      releaseSlot = await Promise.race([slot, aborted])
      armDeadline(_uploadFailure.getUploadTimeoutMs.call(void 0, file.size))
    }
    // The file is already in GCS: completing needs neither the local file
    // nor the direct-upload switch. If it can't, send as usual.
    // Only a Retry continues an earlier upload; a new send starts fresh.
    const previousUploadKey = isRetrying ? directUploadKeys[MessageKey] : undefined
    // Completing posts with the server's clock, so a part that must keep its
    // send's SentAt uploads again instead.
    if (retrySentAt) notSentUploads.delete(MessageKey)
    if (previousUploadKey && !retrySentAt && notSentUploads.delete(MessageKey)) {
      // The bytes are in GCS: any failure here is still "Not sent".
      landedUploads.add(MessageKey)
      uploadTransports.set(MessageKey, 'direct')
      armDeadline(_uploadFailure.getUploadTimeoutMs.call(void 0, 0))
      try {
        const completed = await Promise.race([_uploadDirect.completeWithRetry.call(void 0, _client2.default.send, previousUploadKey), aborted])
        postedByCompletion.add(MessageKey)
        _optionalChain([directUploadSettled, 'optionalCall', _33 => _33(previousUploadKey)])
        tracker.uploaded()
        _store.dispatch.call(void 0, uploadFileActions.SUCCESS(completed, meta))
        return completed
      } catch (err) {
        if (controller.signal.aborted) {
          // The user cancelled the message: close its session (refused if
          // it was completed meanwhile) so nothing completes it later.
          if (userAbortedUploads.has(MessageKey)) {
            _client2.default.send('CancelUpload', { UploadKey: previousUploadKey }).catch(() => undefined)
            _optionalChain([directUploadSettled, 'optionalCall', _34 => _34(previousUploadKey)])
          }
          throw err
        }
        // Still completable: it stays "Not sent" rather than falling back to
        // a local file that may be gone.
        // Refused by the contact cap: uploading it again can't help.
        if (_contactCap.contactCapBlockFromError.call(void 0, err)) throw err
        // GCS never got the last bytes (the web client presumed a final
        // chunk had landed when its answer was unreadable): completing again
        // can't help, so upload it again below. StartUpload opens a new
        // session for the same message.
        if (canCompleteLater(err) && !isUploadNotFinished(err)) throw new (0, _uploadDirect.UploadNotSentError)('complete_failed')
      }
      landedUploads.delete(MessageKey)
      armDeadline(_uploadFailure.getUploadTimeoutMs.call(void 0, file.size))
    }
    const checked = uploadFileCheck ? await uploadFileCheck(file) : file
    // Over the limit on any path: refuse before a byte goes out.
    if (_uploadFailure.isUploadTooLargeSize.call(void 0, checked.size)) throw new (0, _uploadFailure.UploadTooLargeError)()
    const direct = messageUploadTransport && _uploadDirect.directUploadMaybeAvailable.call(void 0, )
      ? await messageUploadTransport(checked)
      : null
    // A background transfer survives suspension and retries on its own, so
    // the deadline is paused while it runs. Everything else (StartUpload, the
    // web transport, the /upload_file fallback) keeps a deadline.
    const pauseDeadlineWhileTransferring = (inner) => ({
      ...inner,
      upload: async (started, onProgress) => {
        clearDeadline()
        try {
          // The native uploader may have completed the upload: keep its file.
          return await inner.upload(started, onProgress)
        } catch (err) {
          // A restart goes back to StartUpload.
          armDeadline(_uploadFailure.getUploadTimeoutMs.call(void 0, 0))
          throw err
        }
      },
    })
    // Once the bytes have landed, an expiry only stops waiting: aborting
    // would cancel a finished upload, while left alone CompleteUpload still
    // completes it, and a Retry completes it by key. A user's cancel still
    // cancels. A failure from here on is "Not sent".
    const onLanded = () => {
      landedUploads.add(MessageKey)
      armDeadline(_uploadFailure.getUploadTimeoutMs.call(void 0, 0), 'stop-waiting')
    }
    const transport = _optionalChain([direct, 'optionalAccess', _35 => _35.background]) ? pauseDeadlineWhileTransferring(direct.transport) : _optionalChain([direct, 'optionalAccess', _36 => _36.transport])
    let usedLegacy = false
    uploadTransports.set(MessageKey, direct ? 'direct' : 'upload_file')
    const upload = direct
      ? _uploadFileWithFallback.uploadFileWithFallback.call(void 0, {
        send: _client2.default.send,
        transport,
        request: {
          ...(fileOnly ? { Purpose: 'file'  } : { Purpose: 'message' , ConversationKey, MessageKey }),
          FileName: checked.name,
          Mime: checked.type || 'application/octet-stream',
          Size: direct.size,
          ...((checked ).durationMs !== undefined && { DurationMs: (checked ).durationMs }),
          ...(direct.posterSize && { PosterSize: direct.posterSize }),
        },
        legacyUpload: () => {
          // /upload_file posts nothing and starts over: not a landed upload.
          usedLegacy = true
          uploadTransports.set(MessageKey, 'upload_file')
          landedUploads.delete(MessageKey)
          armDeadline(_uploadFailure.getUploadTimeoutMs.call(void 0, checked.size))
          return _client2.default.uploadFile(checked, controller.signal)
        },
        onProgress: (sent, total) => tracker.bytes(sent, total),
        // A part's session only stores the file, so a Retry must upload
        // again rather than complete it by key and count it as posted.
        onStarted: uploadKey => { if (!fileOnly) directUploadKeys[MessageKey] = uploadKey },
        onLanded,
        previousUploadKey,
        signal: controller.signal,
      })
      : _client2.default.uploadFile(checked, controller.signal)
    const r = await Promise.race([upload, aborted, stoppedWaiting]) 
    // A direct completion posted the message already.
    if (direct && !usedLegacy && !fileOnly) postedByCompletion.add(MessageKey)
    tracker.uploaded()
    _store.dispatch.call(void 0, uploadFileActions.SUCCESS(r, meta))
    return r
  } finally {
    clearDeadline()
    _optionalChain([releaseSlot, 'optionalCall', _37 => _37()])
  }
}

// Each kind is its own Sentry issue, so the issue list says why sends fail.
const FILE_SEND_FAILURES = {
  upload_timeout: 'File upload timed out',
  upload_network: 'File upload failed on the network',
  upload_http: 'File upload refused by the server',
  upload_error: 'File upload failed',
  post_failed: 'File message not posted',
} 



const fileSendFailureKind = (
  failedStep,
  timedOut,
  described,
) => {
  if (timedOut) return 'upload_timeout'
  if (failedStep === 'send') return 'post_failed'
  if (described.network_error) return 'upload_network'
  if (described.http_status !== undefined) return 'upload_http'
  return 'upload_error'
}

// A class name such as NativeUploadFailedError. Anything else (a native
// error could name itself after its input) is not used as a tag.
const safeErrorName = (name) => /^[A-Za-z][A-Za-z0-9_]{0,63}$/.test(name) ? name : 'Error'

const reportFileSendFailure = (
  err,
  file,
  context









,
) => {
  const described = _uploadFailure.describeUploadError.call(void 0, err)
  const extra = {
    ...described,
    ...context.diagnostics,
    failed_step: context.failedStep,
    is_aborted: context.isAborted,
    timed_out: context.timedOut,
    timeout_ms: _uploadFailure.getUploadTimeoutMs.call(void 0, _optionalChain([file, 'optionalAccess', _38 => _38.size])),
    is_retrying: context.isRetrying,
    mime: _optionalChain([file, 'optionalAccess', _39 => _39.type]),
    size_bytes: _optionalChain([file, 'optionalAccess', _40 => _40.size]),
    elapsed_ms: context.elapsedMs,
  }

  // A cancel is the user's choice, not a failure.
  if (context.isAborted) {
    _log.log.info('File send cancelled', extra)
    return
  }
  // A sibling's failure, reported by that sibling.
  if (err instanceof AttachmentNotSentError) return
  if (context.part && !context.part.claimFailureReport()) return

  // A plain Error: log.error drops transient RestErrors, which is how these
  // failures went unreported. Every part of a message shares the same stack,
  // so the fingerprint, not the stack, splits the issues. Tags hold only
  // codes and types, never names, paths or text.
  const kind = fileSendFailureKind(context.failedStep, context.timedOut, described)
  const errorName = safeErrorName(described.error_name)
  _log.log.error(new Error(FILE_SEND_FAILURES[kind]), {
    extra,
    tags: {
      'file_send.failure': kind,
      'file_send.step': context.failedStep,
      'file_send.error_name': errorName,
      'file_send.http_status': described.http_status === undefined ? 'none' : String(described.http_status),
      'file_send.mime': _optionalChain([file, 'optionalAccess', _41 => _41.type]) || 'unknown',
      'file_send.attachments': String(_nullishCoalesce(_optionalChain([context, 'access', _42 => _42.part, 'optionalAccess', _43 => _43.attachmentCount]), () => ( 1))),
      'file_send.retry': String(context.isRetrying),
      'file_send.transport': context.transport,
      // n/a: the platform doesn't report it (web and desktop).
      'file_send.backgrounded': context.backgrounded === null ? 'n/a' : String(context.backgrounded),
    },
    // An unclassified upload error is split by class (native uploader or
    // not); the other kinds are one cause each, however the error surfaced.
    fingerprint: ['file-send-failure', kind, ...(kind === 'upload_error' ? [errorName] : [])],
  })
}

const sendConversationFile = async (
  ConversationKey,
  rawFile,
  messageKey,
  fileKey,
  diagnostics,
  part,
) => {
  const MessageKey = (messageKey || _uuid.uuidv4.call(void 0, )) 
  const startedAt = Date.now()
  const awayAtSend = _appState.isAppInBackground.call(void 0, )
  const backgroundTripsAtSend = _appState.getBackgroundTrips.call(void 0, )
  let failedStep = 'upload'
  const isRetryingExistingUpload = !!messageKey && !rawFile && !fileKey
  const isSendingExistingFileKey = !!messageKey && !!fileKey
  const isRetrying = isRetryingExistingUpload || isSendingExistingFileKey
  const file = isRetryingExistingUpload ? sentFiles[MessageKey] : rawFile
  const retrySentAt = isRetrying && !part ? sendSentAtOf(ConversationKey, MessageKey) : undefined

  // Check if we have a file to upload
  if (!file && !fileKey) {
    return Promise.reject(new Error('No file available for upload'))
  }

  sentFiles[MessageKey] = file || null
  _contactCap.contactCapBlockStore.set(MessageKey, null)

  // Completing the upload directly already posted the message: the send is
  // a duplicate (the server dedupes it by MessageKey), so its failure must
  // never show a delivered message as failed.
  // Not waited on either: the message is out, whatever the duplicate does.
  const sendAfterCompletion = async (request) => {
    const actionMeta = { ConversationKey, MessageKey }
    _store.dispatch.call(void 0, sendFileToConversationActions.REQUEST(request, actionMeta))
    _store.dispatch.call(void 0, sendFileToConversationActions.SUCCESS({}, actionMeta))
    _client2.default.send('SendMessageToConversation', request).catch((err) => {
      _log.log.info('File message posted by its upload completion; the duplicate send failed', {
        error: _nullishCoalesce(_optionalChain([(err ), 'optionalAccess', _44 => _44.Status]), () => ( _optionalChain([(err ), 'optionalAccess', _45 => _45.name]))),
      })
    })
  }

  const sendUploadedFile = ({ FileKey }) => {
    failedStep = 'send'
    const request = { ConversationKey, MessageKey, FileKey, ...(retrySentAt && { SentAt: retrySentAt }) }
    const postPart = (p) => {
      // The row now has its FileKey, so a Retry after a failed send posts
      // this file on its own.
      _store.dispatch.call(void 0, sendFileToConversationActions.REQUEST(request, { ConversationKey, MessageKey }))
      return p.post(FileKey)
    }
    return (part
      ? postPart(part)
      : postedByCompletion.delete(MessageKey)
      ? sendAfterCompletion(request)
      : _helpers.wsCommand(
        'SendMessageToConversation',
        sendFileToConversationActions,
        request,
        { ConversationKey, MessageKey },
      ))
      .then(() => {
        sentFiles[MessageKey] = null
        landedUploads.delete(MessageKey)
        uploadTransports.delete(MessageKey)
        postedByCompletion.delete(MessageKey)
        notSentUploads.delete(MessageKey)
        delete directUploadKeys[MessageKey]
        uploadAbortControllers[MessageKey] = null
        const tracker = uploadTrackers[MessageKey]
        delete uploadTrackers[MessageKey]
        // A send by FileKey has no tracker; drop any stale failed entry.
        if (tracker) tracker.sent()
        else _uploadProgress.uploadProgressStore.set(MessageKey, null)
      })
  }

  if (fileKey) return sendUploadedFile({ FileKey: fileKey })

  if (!file) {
    return Promise.reject(new Error('Cannot upload undefined file'))
  }

  return uploadFile(file, MessageKey, ConversationKey, isRetrying, part, retrySentAt)
    .then(sendUploadedFile)
    .catch((err) => {
      const timedOut = timedOutUploads.delete(MessageKey)
      const isAborted = userAbortedUploads.delete(MessageKey) || (!timedOut && err.name === 'AbortError')
      uploadAbortControllers[MessageKey] = null
      const tracker = uploadTrackers[MessageKey]
      delete uploadTrackers[MessageKey]
      postedByCompletion.delete(MessageKey)
      if (isAborted) {
        _optionalChain([tracker, 'optionalAccess', _46 => _46.cleared, 'call', _47 => _47()])
        landedUploads.delete(MessageKey)
        notSentUploads.delete(MessageKey)
        delete directUploadKeys[MessageKey]
      } else {
        // The compressed file is kept for Retry (sentFiles), so it resends
        // without compressing again. When the bytes are in GCS but the
        // message isn't out, it's "Not sent" and Retry completes it by key;
        // a final refusal (410/422) isn't.
        _contactCap.contactCapBlockStore.set(MessageKey, _contactCap.contactCapBlockFromError.call(void 0, err))
        const landed = landedUploads.delete(MessageKey)
        const failure = err instanceof _uploadDirect.UploadNotSentError
          ? (err.retryable ? 'not_sent' : 'rejected')
          : landed ? 'not_sent' : _uploadProgress.classifyUploadFailure.call(void 0, err, { timedOut })
        if (failure === 'not_sent') notSentUploads.add(MessageKey)
        _optionalChain([tracker, 'optionalAccess', _48 => _48.failed, 'call', _49 => _49(failure, _uploadProgress.isRetryableUploadFailure.call(void 0, failure) && !!sentFiles[MessageKey])])
      }
      const transport = _nullishCoalesce(uploadTransports.get(MessageKey), () => ( 'none'))
      uploadTransports.delete(MessageKey)
      reportFileSendFailure(err, file, {
        failedStep,
        isAborted,
        timedOut,
        isRetrying,
        elapsedMs: Date.now() - startedAt,
        transport,
        backgrounded: _appState.isAppStateReported.call(void 0, ) ? awayAtSend || _appState.getBackgroundTrips.call(void 0, ) !== backgroundTripsAtSend : null,
        diagnostics,
        part,
      })
      return _store.dispatch.call(void 0, 
        sendFileToConversationActions.FAILURE(
          err,
          { MessageKey, ConversationKey, isAborted },
        ),
      )
    })
}

/* Sends files and optional text as one message. Each file uploads without
 * posting; once all are up, one SendMessageToConversation posts them and the
 * text together. The server stores each file as its own message, followed by
 * the text, all with one SentAt, and rows sharing a SentAt draw as one bubble
 * (processMessages). The optimistic rows share a SentAt too. Nothing posts
 * unless every file uploads: each part then shows its own failure, and its
 * Retry sends that part on its own. Resolves once the message is sent or has
 * failed, with a part's FAILURE action when one failed. */
const sendConversationAttachments = async (
  ConversationKey,
  // A file still being made gives `ready` and `cancel` (PartOfMessage).
  files,
  text,
  ReplyToMessageKey,
  ReplyPreview,
  mentions = [],
  // The caption's key, when the caller keeps the send to offer again
  // (mobile's unsent sends): its own Retry then posts under the same key.
  messageKey,
) => {
  // The server refuses more; refuse before uploading anything.
  if (files.length > _attachments.MAX_ATTACHMENTS_PER_SEND) {
    throw new Error(`A message can carry at most ${_attachments.MAX_ATTACHMENTS_PER_SEND} files`)
  }
  const { text: TextContent, mentions: Mentions } = _mentions.normalizeMessageWithMentions.call(void 0, text, mentions)
  const SentAt = new Date().toISOString()
  const MessageKey = _nullishCoalesce(messageKey, () => ( _uuid.uuidv4.call(void 0, ) ))
  const meta = {
    ConversationKey, MessageKey, isRetrying: true, SentAt,
    ...(Mentions.length ? { Mentions } : {}),
  }

  const attachments = []
  // Until the send posts, leaving the page would lose it (pendingSends).
  const pending = _pendingSends.pendingSendsStore.begin(ConversationKey, files.length)
  let postAll = () => undefined
  const posted = new Promise((resolve, reject) => {
    postAll = sent => sent.then(resolve, reject)
  })
  posted.catch(() => undefined)
  const notSent = () => {
    postAll(Promise.reject(new AttachmentNotSentError()))
    if (TextContent) _store.dispatch.call(void 0, sendMessageToConversationActions.FAILURE(new Error('Not sent'), meta))
  }

  const uploadSlot = createUploadSlots(MAX_PARALLEL_PART_UPLOADS)
  let failureReported = false
  const claimFailureReport = () => {
    if (failureReported) return false
    failureReported = true
    return true
  }
  const parts = files.map(({ file, MessageKey: fileMessageKey, ready, cancel }, i) => sendConversationFile(
    ConversationKey, file, fileMessageKey, undefined, undefined, {
      SentAt,
      uploadSlot,
      attachmentCount: files.length,
      claimFailureReport,
      ...(ready && { ready, cancel }),
      ...(i === 0 && ReplyToMessageKey ? { ReplyToMessageKey, ReplyPreview } : {}),
      post: FileKey => {
        attachments[i] = { MessageKey: fileMessageKey, FileKey }
        pending.fileUploaded()
        if (attachments.filter(Boolean).length === files.length) {
          postAll(_helpers.wsCommand(
            'SendMessageToConversation',
            sendMessageToConversationActions,
            {
              ConversationKey, MessageKey, TextContent, Attachments: attachments,
              ...(ReplyToMessageKey ? { ReplyToMessageKey } : {}),
              ...(Mentions.length ? { Mentions } : {}),
            },
            meta,
          ))
        }
        return posted
      },
    },
  ).then(result => {
    // Settled without reaching post: this file failed or was cancelled.
    if (!attachments[i]) notSent()
    return result
  }))
  if (TextContent) {
    _store.dispatch.call(void 0, sendMessageToConversationActions.REQUEST(
      { ConversationKey, MessageKey, TextContent },
      { ...meta, isRetrying: false },
    ))
  }
  // Like sendConversationFile: the first part's FAILURE action, if any.
  try {
    const results = await Promise.all(parts)
    return _nullishCoalesce(results.find(r => _optionalChain([r, 'optionalAccess', _50 => _50.type]) === sendFileToConversationActions.FAILURE.type), () => ( results[0]))
  } finally {
    pending.end()
  }
}

const abortSendConversationFile = (messageKey) => {
  const ctrl = uploadAbortControllers[messageKey]
  if (ctrl) {
    userAbortedUploads.add(messageKey)
    ctrl.abort()
  }
  uploadAbortControllers[messageKey] = null
}

exports. default = {
  ...boundActions,
  startVideoChat,
  inviteVideoChatSms,
  inviteVideoChatEmail,
  loadConversation,
  loadConversationAroundTime,
  loadConversationAroundMessage,
  sendConversationMessage,
  deleteMessageFromConversation,
  addMessageReaction,
  removeMessageReaction,
  rejoinConversation,
  sendConversationFile,
  sendConversationAttachments,
  abortSendConversationFile,
}
